import { Entity } from '@api';
import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { SendAllAssetsTo } from '@terminal/components/send-all-assets-to/SendAllAssetsTo';
import { useTranslation } from 'react-i18next';

import { useCompetitorsData } from '../../hooks/useCompetitorsData';
import styles from './CompetitorsTab.module.scss';
import { CompetitorsTable } from './competitors-table/CompetitorsTable';

interface CompetitorsTabProps {
  entity: Entity;
}

export const CompetitorsTab = ({ entity }: CompetitorsTabProps) => {
  const { t } = useTranslation(['widget']);

  const { tableData, columnsMeta, isError, isFetching } = useCompetitorsData({
    entityTag: entity.tag,
  });

  const displayedEntityTags = tableData
    .filter(row => row.hasData)
    .map(row => row.entity?.tag) as string[];

  return (
    <ErrorBoundaryWrapper>
      {!!displayedEntityTags.length && (
        <div className={styles.menuBar}>
          <div className={styles.assetsCounter}>
            {t(
              'widget:assetOverview.knowledgeGraph.competitors.assetsCounter',
              {
                count: displayedEntityTags.length,
              }
            )}
          </div>
          <SendAllAssetsTo
            entityTags={displayedEntityTags}
            source="asset_overview"
          />
        </div>
      )}
      <div className={styles.scrollContainer}>
        <CompetitorsTable
          tableData={tableData}
          columnsMeta={columnsMeta}
          isError={isError}
          isFetching={isFetching}
        />
      </div>
    </ErrorBoundaryWrapper>
  );
};
